// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import "./filters"
import auth from '@/components/auth/AuthCheck.js';
import utils from '@/components/utils/Utils.js';


// JWT decoder
var jwtDecode = require('jwt-decode');


import Vuex from 'vuex'
Vue.use(Vuex)

// Vue resource for HTTP 
import VueResource from 'vue-resource';
Vue.use(VueResource);


import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import locale from 'element-ui/lib/locale/lang/en';

Vue.use(ElementUI, { locale })

Vue.use(require('vue-moment'));

import VueMaterialIcon from 'vue-material-icon'
Vue.component(VueMaterialIcon.name, VueMaterialIcon)

import VueChartkick from 'vue-chartkick'
import Chart from 'chart.js'

Vue.use(VueChartkick, {adapter: Chart})

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

// Client side PDF generation
var jsPDF = require('jspdf');
var jsPDFAutotable = require('jspdf-autotable');

var base64Img = require('base64-img');

Vue.config.productionTip = false


// Authentications checks for the Token and expiration along with route module access permissions
import checkJWT from '@/components/auth/checkJWT.js';
Vue.http.headers.common['Authorization'] = localStorage.getItem('id_token');
// Handle the routing
router.beforeEach((to, from, next) => {
    if(to.path != '/login') {
        if(checkJWT.checkAuth()) { 
            // console.log('👍 There is a token, resume. Proceed to page (' + to.path + ')');
            console.log('👍');
            next();
        } else {
            // console.log('👎︎ There is no token, redirect to login. Denied page (' + to.path + ')');
            console.log('👎︎ ');
            next('/login');
        }
    } else {
        console.log('You\'re on the login page');
        next(); 
    } 
});


router.afterEach((to, from) => {
    checkJWT.setupStatus(router)
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js